import axios from 'axios'

const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || 'https://api.tiye.services',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
})

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status
    const url = String(error.config?.url || '')
    const path = window.location.pathname
    const isPublicAuth = url.includes('/password/') ||
      url.includes('/auth/login') ||
      url.includes('/auth/move/login')
    const isAuthPage = path.startsWith('/login') || path.startsWith('/reset-password')

    if (status === 401 && !isPublicAuth && !isAuthPage) {
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      localStorage.removeItem('move_profile')
      localStorage.removeItem('production_profile')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export default api
